import ConvenioList from './ConvenioList'
export {ConvenioList}
export default ConvenioList
